import { APP_ROUTES, useAppTranslation } from "@/utils";
import { PhRCalendarBlank, PhRCaretLeft, PhRClockClockwise, PhRx } from "@payping/icons";
import { Drawer, Flex, Menu } from "@payping/web-components";
import { ComponentProps, FC } from "react";
import { useLocation, useNavigate } from "react-router";
import { HOME_INSTALLMENT_FILTER } from "../../Overview/keys";

interface MobileMenuProps {
  open?: boolean;
  onClose: () => void;
}
const MobileMenu: FC<MobileMenuProps> = ({ onClose, open }) => {
  const { t } = useAppTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleCloseDrawer = () => {
    onClose();
  };

  type MenuItem = Required<ComponentProps<typeof Menu>>["items"][number];

  const items: MenuItem[] = [
    {
      key: APP_ROUTES.home.overview.url,
      icon: <PhRCalendarBlank width={20} />,
      label: t("common.installmentsCalender"),
      itemIcon: <PhRCaretLeft width={16} height={16} />,
      onClick() {
        navigate(`${APP_ROUTES.home.overview.url}?status=${HOME_INSTALLMENT_FILTER.DELAYED}`);
        onClose();
      },
    },
    {
      key: APP_ROUTES.home.purchaseHistory.url,
      icon: <PhRCalendarBlank width={20} />,
      label: t("common.installmentPurchases"),
      itemIcon: <PhRCaretLeft width={16} height={16} />,
      onClick() {
        navigate(APP_ROUTES.home.purchaseHistory.url);
        onClose();
      },
    },
    {
      key: APP_ROUTES.home.paymentHistory.url,
      icon: <PhRClockClockwise width={20} />,
      label: t("common.paymentHistory"),
      itemIcon: <PhRCaretLeft width={16} height={16} />,
      onClick() {
        navigate(APP_ROUTES.home.paymentHistory.url);
        onClose();
      },
    },
  ];
  return (
    <Drawer
      open={open}
      title={<></>}
      onClose={handleCloseDrawer}
      height={"100%"}
      width={"100%"}
      placement={"right"}
      closeIcon={false}
      classNames={{ header: "tw:py-3! tw:px-2!", body: "tw:p-2!" }}
      extra={
        <PhRx
          width={16}
          height={16}
          className="tw:ml-2! tw:mt-1! tw:cursor-pointer tw:p-0!"
          onClick={() => {
            handleCloseDrawer();
          }}
        />
      }
    >
      <Flex className="tw:mt-5! tw:w-full" vertical>
        <Flex className="tw:w-full" vertical>
          <Menu
            className="tw:w-full tw:border-0! tw:py-3!"
            mode="inline"
            items={items}
            defaultOpenKeys={[location.pathname]}
            selectedKeys={[location.pathname, location.pathname + location.search]}
          />
        </Flex>
      </Flex>
    </Drawer>
  );
};

export default MobileMenu;
